const APIS = {
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  BRANCH: "/logisticservice/api/branch/",
  CONTACT_GROUP: "/contactservice/api/contact-groups/",
  // USER_PROFILE: "logisticservice/api/user-profile/",
  SYNC_CONTACT: "/contactservice/api/contact-groups/sync/",
  CHANGE_PASSWORD: "/usermanagementservice/api/user/set-password/",
  CREATE_BRANCH: "/logisticservice/api/branch/",
  BANK_DETAIL: "/usermanagementservice/api/bank-detail/",
  GROUP: "/usermanagementservice/api/role/",
  ADDRESS: "/usermanagementservice/api/address/",
};

export default APIS;
